import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';


@Injectable({ providedIn: 'root' })
export class GlobalInterceptor implements HttpInterceptor {          
    constructor() {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {  
        //console.info('entra a interceptor');
        return next.handle(req).pipe(
            catchError(this.errorHandler)
        );
    }

    errorHandler(error: HttpErrorResponse) {        
        const _errorResponse = {
            ok: false, 
            status: error.status, 
            message: `${((error.error instanceof ErrorEvent) ? 'Client Side Error' : 'Server Side Error' )} copsis::${error.statusText} ${error.url}`, //((error.status === 0 || error.status === 500) ? (`${this._method} copsis::${error.statusText} ${error.url} Error de conexón...`) : error.message), 
            result: error.statusText + " => " + error.url
        };
        //console.warn('errorHandler: ', _errorResponse);
        return throwError(_errorResponse);
    }
}